import { Injectable } from "@angular/core";
import * as XLSX from "xlsx";
import { VendedoresService } from "./vendedores.service";

@Injectable()
export class VendedorSpreadSheetExportService {
  constructor(private vendedoresService: VendedoresService) {}

  async downloadVendedores(searchParams): Promise<void> {
    searchParams = searchParams.set("per_page", "200");
    let page = null;
    let vendedores = [];

    do {
      page = await this.vendedoresService.getSearchResultGrid(searchParams);
      vendedores = vendedores.concat(page.vendedores);
      searchParams = searchParams.set("page", page.pagination.current_page + 1);
    } while (page.pagination.current_page != page.pagination.total_pages);

    window["Vendedores"] = vendedores;

    return this.generateFile(vendedores);
  }

  generateFile(vendedores) {
    const filename = "Vendedores-" + new Date().toISOString() + ".xlsx";
    const header = [
      "nome",
      "status",
      "organizacao",
      "conta",
      "plano",
      "identificacao",
      "data_criacao",
      "email",
      "primeira_transacao",
      "ultima_transacao",
      "numero_transacoes",
      "ticket_medio",
      "total_transacionado",
      "total_recebido",
      "total_recebido_bruto",
      "taxa_total",
      "taxa_medicinae",
      "organizacao",
      "especialidades",
    ];
    const data = [header].concat(
      vendedores.map((vendedor) => {
        let especialidades;
        if (vendedor.vendedor_especialidade_especialidades) {
          especialidades = JSON.parse(
            vendedor.vendedor_especialidade_especialidades
          )
            .map((esp) => esp.nome)
            .join(",");
        }
        return [
          vendedor.vendedor_nome,
          vendedor.vendedor_status_descricao,
          vendedor.organizacao_nome,
          vendedor.conta ? "Sim" : "Não",
          vendedor.plano ? vendedor.plano : "Não informado",
          vendedor.vendedor_identificacao,
          vendedor.vendedor_created_at
            ? new Date(vendedor.vendedor_created_at)
            : "Não disponível",
          vendedor.vendedor_email ? vendedor.vendedor_email : "Não disponível",
          vendedor.min_transacao_created_at
            ? new Date(vendedor.min_transacao_created_at)
            : "Não disponível",
          vendedor.max_transacao_created_at
            ? new Date(vendedor.max_transacao_created_at)
            : "Não disponível",
          vendedor.count_transacao,
          vendedor.ticket_medio_transacao,
          vendedor.sum_transacao_valor_total,
          vendedor.sum_recebivel_valor,
          vendedor.sum_recebivel_valor_bruto,
          vendedor.transacao_taxa_valor_total
            ? vendedor.transacao_taxa_valor_total
            : 0,
          vendedor.transacao_taxa_valor_medicinae
            ? vendedor.transacao_taxa_valor_medicinae
            : 0,
          vendedor.organizacao_nome,
          especialidades ? especialidades : "Não informado",
        ];
      })
    );

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    let wscols = [];
    while (wscols.length < header.length) {
      wscols.push({ wpx: 150 });
    }
    ws["!cols"] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Convênios");

    XLSX.writeFile(wb, filename);
  }
}
